/* BATCHA · 5.38 Preview Vote behaviour.
   Multi-select tiles, one expanding panel that follows the most recent selection,
   and one Klaviyo "Voted for Preview" event per selection.
   Forked from Past Batch Vote v3. The sort control is dropped: two of its three keys
   read a price, and this section has no price. No count is ever rendered (BDS v4.0 s10).
   Governed by Section Templates 5.38 and Klaviyo Flows (event and consent model). */
(function(){
  function init(root){
    if (root.dataset.pvReady) return;
    root.dataset.pvReady = '1';
    var d = root.dataset;
    var grid = root.querySelector('[data-grid]');
    if (!grid) return;
    var choices = Array.prototype.slice.call(root.querySelectorAll('[data-choice]'));
    var writein = root.querySelector('[data-writein]');
    var winput = root.querySelector('[data-writein-input]');
    var panel = root.querySelector('[data-panel]');
    var wpanel = root.querySelector('[data-writein-panel]');
    var pform = root.querySelector('[data-form]');
    var thumb = root.querySelector('[data-panel-thumb]');
    var pname = root.querySelector('[data-panel-name]');
    var pdesc = root.querySelector('[data-panel-desc]');
    var pview = root.querySelector('[data-panel-view]');
    var email = root.querySelector('[data-email]');
    var submit = root.querySelector('[data-submit]');
    var inline = root.querySelector('[data-inline]');
    var msg = root.querySelector('[data-msg]');
    var msgWrap = root.querySelector('[data-msg-wrap]');
    var live = root.querySelector('[data-live]');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var picked = [];
    var done = false;

    function open(el, on){
      if (!el) return;
      if (on){
        if (!el.classList.contains('is-mounted')){ el.classList.add('is-mounted'); void el.offsetHeight; }
        el.classList.add('is-open');
      } else { el.classList.remove('is-open', 'is-mounted'); }
    }
    function showInline(t){ if (inline){ inline.textContent = t; inline.classList.remove('pv-hidden'); } }
    function clearInline(){ if (inline){ inline.classList.add('pv-hidden'); inline.textContent = ''; } }
    function showMsg(t){ if (msg){ msg.textContent = t; msgWrap.classList.remove('pv-hidden'); } }
    function cols(){
      var s = getComputedStyle(grid).gridTemplateColumns;
      return Math.max(1, s.split(' ').filter(function(v){ return v && v !== '0px'; }).length);
    }
    function labelFor(el, k){ return el.dataset['label' + k] || ''; }
    function inView(el){
      var r = el.getBoundingClientRect();
      return r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    }

    /* the panel is a full-row grid item placed at a row boundary, so it never leaves a hole */
    function placePanel(tile){
      var order = Array.prototype.slice.call(grid.querySelectorAll('[data-tile]'));
      var i = order.indexOf(tile);
      if (i < 0) return;
      var c = cols();
      var end = Math.min(order.length - 1, Math.floor(i / c) * c + c - 1);
      var after = order[end];
      if (after.nextSibling !== panel) grid.insertBefore(panel, after.nextSibling);
    }

    function render(scrollTo){
      var active = picked.length ? picked[picked.length - 1] : null;
      choices.forEach(function(el){
        var on = picked.indexOf(el) > -1;
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        var tile = el.closest('[data-tile]');
        if (tile) tile.classList.toggle('is-on', on);
        if (el === writein) el.classList.toggle('is-on', on);
        var st = el.querySelector('[data-state]');
        if (st) st.textContent = done && on ? labelFor(el, 'Done') : (on ? labelFor(el, 'On') : labelFor(el, 'Off'));
      });

      if (done || !active){
        open(panel, false); open(wpanel, false);
        if (live) live.textContent = '';
        clearInline();
        return;
      }

      if (active === writein && wpanel){
        open(panel, false);
        var wslot = wpanel.querySelector('[data-form-slot]');
        if (pform.parentNode !== wslot) wslot.appendChild(pform);
        open(wpanel, true);
      } else {
        open(wpanel, false);
        var pslot = panel.querySelector('[data-form-slot]');
        if (pform.parentNode !== pslot) pslot.appendChild(pform);
        var tile = active.closest('[data-tile]');
        placePanel(tile);
        if (thumb){ thumb.src = tile.dataset.thumb || ''; thumb.alt = tile.dataset.alt || ''; }
        if (pname) pname.textContent = tile.dataset.name || '';
        if (pdesc) pdesc.textContent = tile.dataset.desc || '';
        if (pview){
          if (tile.dataset.url){ pview.href = tile.dataset.url; pview.classList.remove('pv-hidden'); }
          else pview.classList.add('pv-hidden');
        }
        open(panel, true);
        if (scrollTo && !inView(panel)) panel.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
      }
      if (live) live.textContent = picked.length === 1 ? d.liveOne : d.liveMany.replace('{n}', picked.length);
      clearInline();
    }

    function toggle(el){
      if (done) return;
      var i = picked.indexOf(el);
      if (i > -1){
        if (picked[picked.length - 1] !== el){ picked.splice(i, 1); picked.push(el); }
        else picked.splice(i, 1);
      } else picked.push(el);
      render(true);
    }

    choices.forEach(function(el){ el.addEventListener('click', function(){ toggle(el); }); });
    [winput, email].forEach(function(i){ if (i) i.addEventListener('input', clearInline); });
    if (email && submit) email.addEventListener('keydown', function(e){
      if (e.key === 'Enter'){ e.preventDefault(); submit.click(); }
    });

    var reflow;
    window.addEventListener('resize', function(){
      clearTimeout(reflow);
      reflow = setTimeout(function(){
        var active = picked.length ? picked[picked.length - 1] : null;
        if (active && active !== writein && !done) placePanel(active.closest('[data-tile]'));
      }, 150);
    });

    /* ---- Klaviyo: one subscription, then one event per selection ---- */
    function post(url, body){
      return fetch(url, {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: '2023-12-15' },
        body: JSON.stringify(body)
      }).then(function(res){ if (!res.ok) throw new Error(res.status); return res; });
    }
    function sendEvent(item, addr){
      var props = { preview: item.value, is_writein: item.isW };
      if (item.pid) props.product_id = item.pid;
      var body = { data: { type: 'event', attributes: {
        properties: props,
        metric: { data: { type: 'metric', attributes: { name: d.eventName } } },
        profile: { data: { type: 'profile', attributes: { email: addr } } }
      } } };
      var url = 'https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(d.publicKey);
      return post(url, body).then(function(){ return true; })
        .catch(function(){ return post(url, body).then(function(){ return true; }).catch(function(){ return false; }); });
    }

    if (submit) submit.addEventListener('click', function(){
      if (done) return;
      if (!picked.length){ showInline(d.errNochoice); return; }
      var items = picked.map(function(el){
        var isW = el === writein;
        var tile = el.closest('[data-tile]');
        return {
          value: isW ? (winput ? winput.value.trim() : '') : el.dataset.value,
          isW: isW,
          pid: (!isW && tile && tile.dataset.pid) ? tile.dataset.pid : ''
        };
      });
      if (items.filter(function(i){ return i.isW && !i.value; }).length){
        showInline(d.errNowritein); if (winput) winput.focus(); return;
      }
      var addr = (email.value || '').trim();
      if (!addr || addr.indexOf('@') < 1 || addr.indexOf('.') < 0){ showInline(d.errNoemail); email.focus(); return; }
      /* a blank list id or key would post the vote nowhere, or worse, to a default.
         Refuse rather than report a success that did not happen. */
      if (!d.publicKey || !d.listId){ showMsg(d.error); return; }
      clearInline();
      submit.disabled = true;
      var last = items[items.length - 1];
      post('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(d.publicKey), {
        data: { type: 'subscription', attributes: {
          custom_source: d.customSource,
          profile: { data: { type: 'profile', attributes: {
            email: addr,
            properties: {
              last_preview_vote: last.value,
              last_preview_vote_at: new Date().toISOString(),
              last_preview_vote_is_writein: last.isW,
              last_preview_vote_count: items.length
            }
          } } }
        }, relationships: { list: { data: { type: 'list', id: d.listId } } } }
      }).then(function(){
        return Promise.all(items.map(function(i){ return sendEvent(i, addr); }));
      }).then(function(results){
        if (results.filter(Boolean).length === 0) throw new Error('no events recorded');
        done = true;
        render(false);
        showMsg(items.length > 1 ? d.successMulti : d.success);
      }).catch(function(){
        submit.disabled = false;
        showMsg(d.error);
      });
    });

    if (root.classList.contains('pv--reveal') && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting){ root.classList.add('is-revealed'); io.disconnect(); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      io.observe(root);
    } else { root.classList.add('is-revealed'); }
  }

  function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-pv]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
